<template>
  <v-select
    v-model="selectedLabels"
    chips
    item-title="name"
    item-value="id"
    :items="allLabels"
    label="labels for this issue"
    multiple
    @update:focused="focused"
    @update:model-value="change"
  />
</template>
<script setup lang="ts">
import { type Ref, ref, watch } from "vue";
import {
  issueReplaceLabels,
  type Label,
  useIssueListLabels,
} from "../gen/forgejo-vue";
const props = defineProps<{
  owner: string;
  repo: string;
  index: number;
  labels: Label[];
}>();
const emit = defineEmits<(e: "change") => void>();

const selectedLabels = ref(getIds(props.labels));

const { data: allLabelsData } = useIssueListLabels(props.owner, props.repo);
const allLabels: Ref<Label[]> = ref([]);
watch(allLabelsData, () => {
  sortLabels();
});

function getIds(l: Label[]): number[] {
  return l.map((i) => i.id).filter((id) => id !== undefined);
}

function sortLabels() {
  // place the selected labels first
  const l: Label[] = [];
  const all = allLabelsData.value?.data ?? [];
  for (const label of all) {
    if (label.id !== undefined && selectedLabels.value.includes(label.id)) {
      l.push(label);
    }
  }
  for (const label of all) {
    if (label.id !== undefined && !selectedLabels.value.includes(label.id)) {
      l.push(label);
    }
  }
  allLabels.value = l;
}
function focused(focus: boolean) {
  if (!focus) {
    sortLabels();
  }
}
async function change() {
  await issueReplaceLabels(props.owner, props.repo, props.index, {
    labels: selectedLabels.value,
  });
  emit("change");
}
</script>
